  export function showOverlay (textBox: HTMLElement) {
    const selectors = {
      overlay: '[data-overlay]',
      overlayClose: '[data-overlay-close]',
    }

    const overlayElement = document.querySelector(selectors.overlay);

    const closeModal = () => {
      document.querySelectorAll(selectors.overlayClose)
      .forEach((el: HTMLElement) => {
        el.addEventListener('click', () => {
          overlayElement.classList.remove('bg-black/[0.25]', 'fixed', 'inset-0', 'z-20');
          textBox.remove();
        });
      }); 
    }

    const hideOverlay = (textBox: HTMLElement) => {
      overlayElement.addEventListener('click', () => {
        overlayElement.classList.remove('bg-black/[0.25]', 'fixed', 'inset-0', 'z-20');
        textBox.remove();
      })
    }

    overlayElement.classList.add('bg-black/[0.25]', 'fixed', 'inset-0', 'z-20');
    hideOverlay(textBox);
    closeModal(textBox);
  }